import React, { useEffect, useState } from 'react';
import ChatDemo from './feature/demo/liveDemo';
import FinalDemo from 'feature/chatbot/container/finalDemo';
import ScaleBoat from 'feature/scalBoat/scaleBoat';

const App: React.FC = () => {

  type ThemeType = 'theme1' | 'f_demo';
  const [type, setType] = useState<ThemeType>('theme1');


  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const paramValue = urlParams.get('demo');
    if (paramValue === 'theme1' || paramValue === 'f_demo') {
      setType(paramValue as ThemeType);
    } else {
      setType('theme1'); // Default to 'theme1' if invalid or missing
    }
  }, []);
  return (
    <>
      {/* <Chatbot /> */}
      {/* {type === 'theme1' && <ChatDemo />}
      {type === 'f_demo' && <FinalDemo />} */}
      <ScaleBoat />
    </>
  )
    ;
};

export default App;
